module.exports = __webpack_public_path__ + "1.5.0-unryo/img/eu.530a3df4.svg";